/**
 * Builds a site locale (`en-nl`) from separate language and country values.
 * Returns null when either part is missing.
 */
export default function composeLocale(
  language?: string | null,
  country?: string | null,
): string | null {
  const lang = language?.trim();
  const countryCode = country?.trim();
  if (!lang || !countryCode) return null;

  return `${lang}-${countryCode}`.toLowerCase();
}
